import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoaderService } from '../../services/loader/loader.service';
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})

export class LoaderComponent implements OnInit {
  isLoading: BehaviorSubject<boolean> = this.loaderService.isLoading;
  loadState: boolean;

  constructor(private loaderService: LoaderService, private ref: ChangeDetectorRef) { }

  ngOnInit() {
    this.isLoading.subscribe(data => {
      this.loadState = data;
      this.ref.detectChanges();
    })
  }
}
